import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import { translatedMessage } from '../../service/LanguageService';
import { CompetitionService } from '../../service/CompetitionService';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import EnumService from '../../service/EnumService';

const CompetitionWorkDurationEditDialog = (props) => {
    const [competition, setCompetition] = useState(null);
    const [workingHoursList, setWorkingHoursList] = useState([])

    const toast = useRef(null);

    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        const getWorkingHours = async () => {
            const _workingHoursList = await EnumService.getEntityLookupByField("NOM:WORKING_HOURS")
            setWorkingHoursList(_workingHoursList)
        }

        setCompetition({ ...props?.value, workingHours: props?.value?.workingHours !== null ? props?.value?.workingHours.id : null });
        getWorkingHours()

    }, [props.value]);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: competition ? competition : props?.value,
        validate: (data) => {
            let errors = {};

            if (!data.workingHours) {
                errors.workingHours = translatedMessage('form.error.job.workingHours.required');
            }

            return errors;
        },
        onSubmit: (data) => {
            // console.log(data);
            saveCompetition(data);
        }
    });

    const hideDialog = () => {
        if (typeof props.visibleSetter === 'function') {
            props.visibleSetter(false);
        }
        formik.resetForm();
    };

    const saveCompetition = (data) => {
        data.workingHours = { id: data.workingHours }
        competitionService.saveCompetitionJob(data)
            .then((savedData) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(savedData, true);
                }
                hideDialog();
                formik.resetForm();
            })
            .catch((error) => {
                if (typeof props.afterSave === 'function') {
                    props.afterSave(null, false, error);
                }
            });
    };

    const dialogFooter = (
        <>
            <Button label={translatedMessage('generic.cancel')} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={translatedMessage('generic.save')} icon="pi pi-save" className="p-button-text" form="workingHours-form" type="submit" />
        </>
    );

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error text-align-left">{formik.errors[name]}</small>;
    };

    return (
        <>
            <Toast ref={toast} />

            <Dialog
                visible={props.visible}
                style={{ width: '450px' }}
                header={translatedMessage('job.workingHours')}
                modal
                className="p-fluid"
                footer={dialogFooter}
                onHide={hideDialog}
            >
                <form id="workingHours-form" onSubmit={formik.handleSubmit}>
                    <div className="p-inputgroup">
                        <span className="p-float-label">
                            <Dropdown
                                id="workingHours"
                                name="workingHours"
                                value={formik.values.workingHours}
                                options={workingHoursList}
                                onChange={(e) => formik.setFieldValue("workingHours", e.value)}
                            />
                            <label htmlFor="workingHours" className={classNames({ 'p-error': isFormFieldValid('workingHours') })}>
                                {translatedMessage('job.workingHours')} *
                            </label>
                        </span>
                    </div>
                    {getFormErrorMessage('workingHours')}


                </form>
            </Dialog>
        </>
    );
};

export default CompetitionWorkDurationEditDialog;
